<template>
  <span v-if="hasDiscount" class="discountBadge">{{ Math.round((price / insteadOf - 1) * 100) }}%</span>
</template>

<script lang="ts">
import Component from 'vue-class-component';
import {Prop} from 'vue-property-decorator';
import Vue from 'vue';

@Component
export default class ProductDiscountBadge extends Vue {
  @Prop({type: Number, default: 0}) readonly price!: number;
  @Prop({type: Number, default: 0}) readonly insteadOf!: number;

  get hasDiscount(): boolean {
    return this.insteadOf > 0 && this.price / this.insteadOf - 1 <= -0.01;
  }
}
</script>

<style scoped lang="scss">
@use '../stylesheets/Variables.scss' as *;


.discountBadge {
  display: inline-block;
  flex: none;
  background-color: $price-color-discount;
  color: $shop-white;
  font-weight: bold;
  font-size: 15.84px;
  text-align: center;
  width: 43.56px;
  height: 43.56px;
  border-radius: 50%;
  line-height: 43.56px;
  white-space: nowrap;

  @media (max-width: 959px) {
    width: auto;
    height: auto;
    border-radius: 999px;
    line-height: 1.4;
    font-size: 15.3px;
    padding: 0.1em 0.6em;
  }
}
</style>
